module.exports = __webpack_public_path__ + "img/compass.d45a0f87.svg";